<template>
    <JobPage />
</template>

<script setup lang="ts">
    import JobPage from '~/components/job/JobPage.vue';
</script>
